import * as React from 'react';
import { ContextModalProps } from '@mantine/modals';
import { Text, Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';

// Components
import { FormScaffolding, FormScaffoldingProps, FormHandle } from '../../Form/FormScaffolding';

// Types
import { IManifestFieldHydrated } from '../../../manifests/types';

interface ContactModalProps {
    subManifest: IManifestFieldHydrated[];
    data?: Record<string, any>;
    onSave: FormScaffoldingProps['onSave'];
    onCancel: FormScaffoldingProps['onCancel'];
}

export const ContactModal = ({ context, id, innerProps }: ContextModalProps<ContactModalProps>) => {
    const FormRef = React.useRef<FormHandle>(null);
    const { t } = useTranslation('common');

    return (
        <>
            <FormScaffolding
                ref={FormRef}
                sections={[
                    {
                        name: 'Contact Details',
                        manifest: innerProps.subManifest
                    }
                ]}
                data={innerProps.data}
                onSave={innerProps.onSave}
                onCancel={innerProps.onCancel}
            />
            <Button fullWidth mt="md" onClick={() => context.closeModal(id)}>
                <Text transform="capitalize">{t('close')}</Text>
            </Button>
        </>
    );
};
